<template>
    <div class="content-container">
        <div id="module-content"></div>
         <!-- {{ moduleData }} -->
    </div>


    <!-- Modal preview data -->
    <template v-if="newModalVisible && !moduleLocked">
        <VisibleModal />
        <div class="modal__overlay">
            <div class="contentPreview__modal">

                <div class="contentPreview__modal__title">
                    <h2 v-if="thiscontentType === 'forum'">Foro</h2>
                    <h2 v-else-if="thiscontentType === 'attach'">Actividad para entregar</h2>
                    <h2 v-else-if="thiscontentType === 'commentswall'">Actividad de muro</h2>

                    <i class="material-icons contentPreview__modal__close" @click="newModalVisible = false">close</i>
                </div>

                
                <!-- display content data -->
                <div class="contentPreview__modal__body">
                    <div class="contentPreview__modal__date">
                        Fecha de entrega: --/--/--
                    </div>
                    <div v-html="newModalContent"></div>


                    <div v-if="thiscontentType === 'forum'">
                        <div class="forum__actions">
                            <button><i class="material-icons-outlined">favorite_border</i> Me gusta</button>
                            <button><I class="material-icons-outlined">comment</I> Comentar</button>
                        </div>
                        <EmptyState v-if="thiscontentType === 'forum'"
                     icon="comments_disabled" title="Todavía no hay comentarios" message="Anímate y se el primero en compartir tu reflexión."/>
                    </div>
                    
                    <div v-else-if="thiscontentType === 'attach'">
                        <div class="activity__actions">
                            <h3>Archivos subidos</h3>
                            <p>Aquí podrás encontrar los archivos que has subido. Recuerda que puedes subir los archivos que necesites.</p>
                        </div>
                        <EmptyState icon="cloud_upload" title="Todavía no has subido archivos" message="Sube el archivo desde tu ordenador." subMessage="El peso máximo es de 29MB y los formatos permitidos son DOC, PPT, PDF." uploadFileView="true"/>
                    </div>

                    <div v-else-if="thiscontentType === 'commentswall'">

                        <div class="commentsWall__swipe"
                            v-if="thisCommentsWallHeaders.length > 1 && isMobile"
                        >
                            <i class="material-icons">swipe_left</i>
                            <span>Desliza hacia la izquierda para ver todos los temas</span>
                        </div>
                        
                        <div class="module_muro_container">
                            <div class="module_muro" >
                                <div
                                v-for="header in thisCommentsWallHeaders" 
                                :key="header" 
                                class="module_muro__column">
                                    <h2 class="module_muro__header">{{ header }}</h2>
                                </div>
                            </div>

                            <div class="module_muro">
                                <div
                                    v-for="header in thisCommentsWallHeaders" 
                                    :key="header" 
                                    class="module_muro__column"
                                >
                                    <button class="module_muro__addComment">Agregar reflexión <i class="material-icons">add_comment</i></button>
                                </div>
                            </div>


                        </div>

                    </div>  

                    
                </div>

            </div>
        </div>
    </template>



    <!-- //Esto es provisorio para contentShare -->
    <template  v-if="modalPreview && !moduleLocked">
        <VisibleModal />
        <div class="modal__overlay">
            <div class="contentShare__modal">
                <i class="material-icons contentShare__modal__close" @click="modalPreview = false; modalView = 1">close</i>
                <div class="contentShare__modal_views">
                    <span 
                        @click="modalView = 1" 
                        :class="`contentShare__modal_view${modalView === 1 ? '--active' : ''}`"
                    >
                        {{$t('finalPractice.TEACHER_TITLE')}}
                    </span>
                    <span 
                        @click="modalView = 2" 
                        :class="`contentShare__modal_view${modalView === 2 ? '--active' : ''}`"
                        v-if="modalPreview.hideSharedTab !== true"
                    >
                        {{$t('finalPractice.STUDENT_TITLE')}}
                    </span>
                </div>
                <div class="contentShare__modal__body">
                    <section class="contentShare__modal_iframe">
                        <p class="contentShare__modal_iframe__disclaimer" v-if="modalView === 1">{{$t('finalPractice.TEACHER_DISCLAIMER')}}</p>
                        <p class="contentShare__modal_iframe__disclaimer" v-if="modalView === 2">{{$t('finalPractice.STUDENT_DISCLAIMER')}}</p>
                        <div v-html="modalView === 1 ? modalPreview.OwnTab : modalPreview.SharedTab"></div>
                    </section>
                    
                    <div class="contentShare__modal__buttons">
                        <button @click="modalPreview = false; modalView = 1" class="contentShare__modal_button">Cancelar</button>
                        <button 
                            @click="confirmModal = true" 
                            class="contentShare__modal_button"
                            :disabled="true"
                        >
                            Continuar <i class="material-icons-outlined">arrow_forward</i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </template>


    <!-- moduleLocked EmptyState -->
    <EmptyState v-if="moduleLocked" :icon="'event'" :title="'Este contenido no se encuentra disponible aún'" :message="`<span>Podrás visualizarlo a partir del <strong>${moduleLockedDate}</strong><br>Si quieres ver más material, te invitamos a que recorras los distintos artículos, podcast y charlas que hemos seleccionado para ti en la sección <a href=/resources style=color:#9E5498;font-weight:600;>Recursos</a></span>`" :color="'pink'"/>

</template>

<script setup>
import { useStore } from 'vuex';

import { useRouter, useRoute } from 'vue-router';
// import { onMounted, ref, watch, defineProps, defineEmits, defineExpose, inject } from 'vue';

import { onMounted, ref, watch, defineProps, defineEmits, defineExpose } from 'vue';
import { useI18n } from 'vue-i18n';
import VisibleModal from '@/components/VisibleModal.vue';
import EmptyState from '@/components/EmptyState.vue';

// eslint-disable-next-line no-unused-vars
import { dragscroll } from 'vue-dragscroll';
const isMobile = ref(window.innerWidth <= 1000)
// resize check
window.addEventListener('resize', () => {
    isMobile.value = window.innerWidth <= 1000
})

const modalPreview = ref(undefined) //Esto es provisorio para contentShare
const modalView = ref(1) //Esto es provisorio para contentShare


const props = defineProps({
    editMode: Boolean,
    moduleId: String,
    courseId: String,
    finalPractice: String,
    status: String
});

const emit = defineEmits(['dataLoaded','editContent','hasPortada','orderActive'])

const router = useRouter();
const route = useRoute();
const store = useStore();
const { t } = useI18n()
// const copyToClipboard = inject('copyToClipboard');

const moduleDataLoaded = ref(false);
const moduleData = ref();
const moduleLocked = ref(false);
const moduleLockedDate = ref(null);
const renderContentTypes = ['HTML','FORUM','ATTACH', 'COMMENTSWALL','TRIP','CONTENTSHARE', 'ACCESO_DIRECTO']; 

const setStatusMessage = (status) => {
    let div = document.createElement('div');
    let message;
    let icon;
    switch(status){
        case 'CONTENT_PENDING_MANDATORY':
            message = t('module.activities.statuses.CONTENT_PENDING_MANDATORY');
            icon = 'error_outline';
            div.style.color = 'black';
            break;
        case 'CONTENT_PENDING_OPTATIVE':
            message = t('module.activities.statuses.CONTENT_PENDING_OPTATIVE');
            icon = 'check_circle_outline';
            div.style.color = 'black';
            break;
        case 'CONTENT_PENDING_OUT_TIME':
            message = t('module.activities.statuses.CONTENT_PENDING_OUT_TIME');
            icon = 'error_outline';
            div.style.color = '#F57055';
            break;
        case 'CONTENT_FINISHED_IN_TIME':
            message = t('module.activities.statuses.CONTENT_FINISHED_IN_TIME');
            icon = 'check_circle';
            div.style.color = '#009696';
            break;
        case 'CONTENT_FINISHED_OUT_TIME':
            message = t('module.activities.statuses.CONTENT_FINISHED_OUT_TIME');
            icon = 'check_circle';
            div.style.color = '#009696';
            break;
    }
    div.innerHTML = `<i class="material-icons">${icon}</i><span>${message}</span>`;
    div.classList.add('status-message');
    return div;
}

//Order contents in moduleEditor **************************************************************************************
function moveInArray(array, from, to){
    const elementoSacado = array.splice(from, 1)[0];
    array.splice(to, 0, elementoSacado);
}

let originalModuleContents;

const orderContentsByIndex = ()=> {
    moduleData.value.contents.forEach(cont => {
        let item = document.querySelector(`.contentId-${cont.id}`);
        item.style.order = moduleData.value.contents.indexOf(cont)
    })
}

function orderContent(upDown,content){
    emit('orderActive',true);
    let container = document.querySelector('#module-content');
    
    if(!container.classList.contains('edit-order-mode')){
        container.classList.add('edit-order-mode');
        originalModuleContents = [...moduleData.value.contents];
    } 

    let contentElement = document.querySelector(`.contentId-${content.id}`);
    if(!contentElement.classList.contains('edit-order-itemActive')) contentElement.classList.add('edit-order-itemActive');

    let index = moduleData.value.contents.indexOf(content)
    if(upDown == 'up'){
        contentElement.querySelector('.editable-content__options__downOrder').style.opacity = '1';
        let hasPortada = moduleData.value.contents.some(cont => cont.htmlType == 'PORTADA');
        if(hasPortada ? index > 1 : index > 0){
            moveInArray(moduleData.value.contents, index, index-1); 
            if( (hasPortada && index-1 == 1) || (!hasPortada && index-1 == 0) ){
                contentElement.querySelector('.editable-content__options__upOrder').style.opacity = '.4';
            }
        }
        else contentElement.querySelector('.editable-content__options__upOrder').style.opacity = '.4';
 
    }
    if(upDown == 'down'){
        contentElement.querySelector('.editable-content__options__upOrder').style.opacity = '1';
        if(index < moduleData.value.contents.length-1){
            moveInArray(moduleData.value.contents, index, index+1);
            if(index+1 >= moduleData.value.contents.length-1){
                
                contentElement.querySelector('.editable-content__options__downOrder').style.opacity = '.4';
            }
        }
        
        else contentElement.querySelector('.editable-content__options__downOrder').style.opacity = '.4';
    }
    // Agregar style order
    orderContentsByIndex();
    
    window.scrollTo({
        top: contentElement.offsetTop - (window.innerHeight / 2) + (contentElement.offsetHeight / 2),
        behavior: 'smooth' 
    });
   
}

function cancelContentOrder(){
    moduleData.value.contents = originalModuleContents;
    let container = document.querySelector('#module-content');
    container.classList.remove('edit-order-mode');
    let activeElement = document.querySelector('.edit-order-itemActive');
    activeElement.classList.remove('edit-order-itemActive');
    orderContentsByIndex();
    emit('orderActive',false);
}

async function confirmContentOrder(){
    let contentElement = document.querySelector('.edit-order-itemActive');
    let scrollPosition = contentElement.offsetTop - 840;
    contentElement.classList.remove('edit-order-itemActive');
    let model = {
        moduleCfgId: props.moduleId,
        contentCfgId: moduleData.value.contents.map(cont => cont.id),
        courseCfgId: route.params.courseCfgId
    }    
    await store.dispatch('contentEditor_changeOrder', model);
    await getModule(props.moduleId);
    let container = document.querySelector('#module-content');
    container.classList.remove('edit-order-mode');
    window.scrollTo(0, scrollPosition);
    emit('orderActive',false);
}
// ***********************************************************************************************
const newModalVisible = ref(false);
const newModalContent = ref(null);
const thiscontentType = ref('forum'); // Default to 'forum'
const thisCommentsWallHeaders = ref(null);


const openNewModal = (content, contentType, commentsWallHeaders = null) => {
    newModalVisible.value = true;

    // Set content type
    thiscontentType.value = contentType;

    let contentClean = content.replace(/\[BEGIN_(\w*)\]?/g,'').replace(/\[END_(\w*)\]?/g,'');

    newModalContent.value = contentClean;

    if (contentType === 'commentswall') {
        thisCommentsWallHeaders.value = commentsWallHeaders;
    }
};

function removeCustomText(data) {
    return data.replace(/\[BEGIN_OWN\].*?\[END_OWN_BOTON\]/gs, '');
}

async function redirectToContent(contentCfgId){
    if(props.editMode){
        let req = await store.dispatch('contentEditor_getContentCfg', contentCfgId);
        console.log(req.data)
        openNewModal(JSON.parse(req.data.data).Data, req.data.type.toLowerCase(), req.data.commentsWallHeaders)
    }else{
        let req = await store.dispatch('courses_contentInstance', { courseId: props.courseId, contentCfgId } )
        let contentType = req.data.contentType.toLowerCase() == "activity" ? 'activity/attach' : req.data.contentType.toLowerCase() == "commentswall" ? 'muro' : 'forum'
        router.push(`/course/${req.data.courseId}/module/${req.data.moduleId}/${contentType}/${req.data.contentId}?redirect=true`);
    }
}


async function getModule(id){
    let container = document.querySelector('#module-content');
    container.innerHTML = '';
    //moduleLocked.value = false;
    //moduleLockedDate.value = null;
    moduleDataLoaded.value = false
    try {
        let req;
        props.editMode
            ? req = await store.dispatch('contentEditor_module',id)
            : req = await store.dispatch('courses_module',id);
        moduleData.value = req.data;
        if(moduleData.value.contents.length){
            let $fragment = document.createDocumentFragment();
            moduleData.value.contents.forEach(content => {

                if(renderContentTypes.includes(content.type.toUpperCase())){
                    try {
                        content.data = JSON.parse(content.data);
                    } catch (e){
                        console.log("Error parse JSON contentId " + content.id + e);
                    }
                }
                else return;
                let data = null;
                let preview = null;
                if (content.data.Data) {
                    content.data.Data = removeCustomText(content.data.Data);
                }
                let dataClean = content.data.Data ? content.data.Data.replace(/\[BEGIN_(\w*)\]?/g,'').replace(/\[END_(\w*)\]?/g,'') : '';
                let previewClean = content.data.Preview ? content.data.Preview.replace(/\[BEGIN_(\w*)\]?/g,'').replace(/\[END_(\w*)\]?/g,'') : '';
               
                if (content.type.toUpperCase() == 'CONTENTSHARE') {
                    console.log(content.data)
                    data = document.createElement('div');
                    if(typeof(content.data.Subcontents) == 'string' ){
                        console.log('es string')
                        content.data.Subcontents = JSON.parse(content.data.Subcontents);
                    }
                    if(props.editMode) data.classList.add('editable-content');

                    // Iterar sobre los datos de contenido compartido
                    // Crear una sección para el contenido compartido
                    let section = document.createElement('section');
                    section.className = 'finalPractice';
                    section.id = `contentshare--${content.id}`

                    // Crear la segunda sección de datos
                    let welcomeData2 = document.createElement('div');
                    welcomeData2.className = 'finalPractice__data';
                    let welcomeData2Span = document.createElement('span');
                    let welcomeData2Strong = document.createElement('strong');
                    welcomeData2Strong.textContent = 'Aprender haciendo | ';
                    welcomeData2Span.appendChild(welcomeData2Strong);
                    
                    let subtitle = 'Dinámicas para realizar en clase';
                    let description = 'Primero, selecciona entre las siguientes actividades cuál deseas realizar en clase con tus estudiantes.';
                    if (content.data.Subcontents.length == 1) {
                        subtitle = 'Dinámica para realizar en clase';
                        description = 'Haz clic para conocer la propuesta de la actividad para realizar con tus estudiantes.';
                    }

                    welcomeData2Span.appendChild(document.createTextNode(subtitle));
                    welcomeData2.appendChild(welcomeData2Span);
                    let welcomeData2P = document.createElement('p');
                    welcomeData2P.textContent = description;
                    welcomeData2.appendChild(welcomeData2P);

                    // Agregar las dos secciones de datos a la sección principal
                    section.appendChild(welcomeData2);

                    // Crear la sección de opciones
                    let optionsSection = document.createElement('section');
                    optionsSection.className = 'finalPractice__cards';

                    // Iterar sobre las opciones
                    content.data.Subcontents.forEach((option) => {
                        let optionDiv = document.createElement('div');
                        //optionDiv.className = `finalPractice__card${(content.data.SelectedOption && content.data.SelectedOption !== option.Identifier) ? '--disabled' : ''}`;
                        optionDiv.className = `finalPractice__card`;
                        /*if (!(content.data.SelectedOption && content.data.SelectedOption !== option.Identifier)) {
                            optionDiv.addEventListener('click', () => {
                                modalPreview.value = option;
                                modalPreview.value.contentId = content.id;
                                //modalPreview.value.idx = idx;
                                modalPreview.value.isSelected = !!content.data.SelectedOption
                            });
                        }*/
                        optionDiv.addEventListener('click', () => {
                            modalPreview.value = option;
                            //modalPreview.value.contentId = content.id;
                            //modalPreview.value.idx = idx;
                            //modalPreview.value.isSelected = !!content.data.SelectedOption
                        });
                        let optionImg = document.createElement('img');
                        optionImg.src = option.ImagePreview;
                        optionDiv.id = `contentshare--${content.id}--${option.Identifier}`
                        optionDiv.appendChild(optionImg);

                        optionsSection.appendChild(optionDiv);
                    });

                    section.appendChild(optionsSection);
                    let divLink = undefined
                    if (content.data.LinkToShare) {
                        divLink = document.createElement('div');
                        divLink.classList.add('finalPractice__link');
                        divLink.innerHTML = `
                            <span>
                                Enlace para compartir:
                            </span>
                        `;
                        const button = document.createElement('button')
                        button.classList.add('finalPractice__linkButton')
                        button.innerText = 'Copiar link'
                        button.addEventListener('click', async () => {
                            const linkToShare = content.data.LinkToShare;
                            if (typeof linkToShare === 'string' && linkToShare.trim() !== '') {
                                try {
                                    await navigator.clipboard.writeText(linkToShare);
                                    store.dispatch('notifications_create', { text: 'Link copiado al portapapeles.' });
                                } catch (err) {
                                    console.error(err);
                                    store.dispatch('notifications_create', { text: 'Ha ocurrido un error copiando el link.' });
                                }
                            } else {
                                console.error('El valor de linkToShare no es una cadena de texto válida.');
                                store.dispatch('notifications_create', { text: 'Ha ocurrido un error copiando el link.' });
                            }
                        });
                        divLink.appendChild(button)
                        section.appendChild(divLink);
                    }
                    // Agregar la sección principal al div principal
                    data.appendChild(section);

                    $fragment.appendChild(data);
                }

                else if(content.type.toUpperCase() == 'TRIP'){
                    data = document.createElement('div');
                    //data = dataClean;
                    if(props.editMode) data.classList.add('editable-content');
                    let ownLink = content.data.OwnLink;
                    let linkToShare = content.data.LinkToShare;
                    let contentHTML = dataClean;
                    ownLink
                        ? contentHTML = contentHTML.replace("[[<TRIP_DOCENTE_URL>]]",ownLink)
                        : contentHTML = contentHTML.replace("[[<TRIP_DOCENTE_URL>]]",'')
                    linkToShare
                        ? contentHTML = contentHTML.replace("[[<TRIP_ALUMNODOCENTE_URL>]]",linkToShare)
                        : contentHTML = contentHTML.replace("[[<TRIP_ALUMNODOCENTE_URL>]]",'Enlace no disponible')

                    data.innerHTML = contentHTML;
                    let copyLinkBtn = data.querySelector('#shareTRIPBtn');
                    if (copyLinkBtn) {
                        const linkView = document.createElement('a');
                        linkView.innerHTML = 'www.ejemplo.com';
                        copyLinkBtn.parentNode.insertBefore(linkView, copyLinkBtn);
                    }
                    // if(linkToShare){
                    //     copyLinkBtn.innerText = 'Copiar link'
                    //     copyLinkBtn.addEventListener('click', async () => { await copyToClipboard(linkToShare) } );
                    // }else if(!props.editMode){
                    //     copyLinkBtn.style.display = 'none'
                    // }
                    // if(!ownLink){
                    //     let ownLinkBtn = data.querySelector('#ownTRIPBtn');
                    //     ownLinkBtn.addEventListener('click', e => e.preventDefault())
                    //     ownLinkBtn.style.opacity = '0.5'
                    //     ownLinkBtn.style.cursor = 'default'
                    // }
                    $fragment.appendChild(data);
                }
                else if(content.type.toUpperCase() == 'HTML'){
                    data = document.createElement('div');
                    data.innerHTML = dataClean;
                    if(props.editMode){
                        content.htmlType == 'PORTADA'
                            ? ( data.classList.add('portada-content'), emit('hasPortada',content.id) )
                            : data.classList.add('editable-content');
                        content.htmlType == 'DIVISION' ? data.classList.add('division') : '';
                    } 
                    else data.classList.add('content');
                    if(content.htmlType.toUpperCase() == 'ACCESO_DIRECTO'){
                        let btn = data.querySelector('.btn-acceso-directo');
                        btn.addEventListener('click', (e)=>{
                            e.preventDefault();
                           redirectToContent(content.data.RedirectContentCfgId); 
                        })
                    }
                    $fragment.appendChild(data);
                }
                else if(content.type.toUpperCase() == 'ATTACH'){
                    preview = document.createElement('div');
                    preview.innerHTML = previewClean;
                    if(props.editMode) preview.classList.add('editable-content');

                    let hasAttachButton;
                    let $links = preview.getElementsByTagName('a');
                    if(!$links.length){
                        hasAttachButton = false;
                    }
                    else{
                        for(let link of $links){
                            if (link.classList.contains('tinymce-link')) {
                                continue;
                            }
                            hasAttachButton = true;
                            link.addEventListener('click', (e)=>{
                                e.preventDefault();
                                if(!props.editMode) router.push(`/course/${props.courseId}/module/${props.moduleId}/activity/attach/${content.id}`);
                                else openNewModal(content.data.Data, 'attach');
                            })
                            link.setAttribute('href', !props.editMode ? `/course/${props.courseId}/module/${props.moduleId}/activity/attach/${content.id}` : '');
                        }
                    }

                    if(!hasAttachButton){
                        let attachButton = document.createElement('a');
                        attachButton.classList.add('attach-button');
                        attachButton.innerHTML = 'Ir a la actividad';
                        attachButton.addEventListener('click', ()=> {
                            if(!props.editMode) router.push(`/course/${props.courseId}/module/${props.moduleId}/activity/attach/${content.id}`);
                            else openNewModal(content.data.Data, 'attach')
                        })
                        preview.appendChild(attachButton);
                    }

                    $fragment.appendChild(preview);

                    if(content.displayMessage && !props.editMode){
                        if( !(moduleData.value.courseIsFinished && content.displayMessage == 'CONTENT_PENDING_OUT_TIME') ){
                            let status = setStatusMessage(content.displayMessage);
                            $fragment.appendChild(status);
                        }
                    }

                }
                else if(content.type.toUpperCase() == 'FORUM'){
                    preview = document.createElement('div');
                    preview.innerHTML = previewClean;
                    if(props.editMode) preview.classList.add('editable-content');

                    let hasForumButton;
                    let $links = preview.getElementsByTagName('a');
                    if(!$links.length){
                        hasForumButton = false;
                    }
                    else{
                        for(let link of $links){
                            if (link.classList.contains('tinymce-link')) {
                                continue;
                            }
                            hasForumButton = true;
                            link.addEventListener('click', (e)=>{
                                e.preventDefault();
                                if(!props.editMode) router.push(`/course/${props.courseId}/module/${props.moduleId}/forum/${content.id}`)
                                else openNewModal(content.data.Data, 'forum');
                            })
                            link.setAttribute('href', !props.editMode ? `/course/${props.courseId}/module/${props.moduleId}/forum/${content.id}` : '')
                        }
                    }

                    if(!hasForumButton){
                        let forumButton = document.createElement('a');
                        forumButton.classList.add('forum-button');
                        forumButton.innerHTML = 'Ir al foro';
                        forumButton.addEventListener('click', ()=> {
                            if(!props.editMode) router.push(`/course/${props.courseId}/module/${props.moduleId}/forum/${content.id}`)
                            else openNewModal(content.data.Data, 'forum');
                        })
                        preview.appendChild(forumButton);
                    }

                    $fragment.appendChild(preview);

                    if(content.displayMessage && !props.editMode){
                        if( !(moduleData.value.courseIsFinished && content.displayMessage == 'CONTENT_PENDING_OUT_TIME') ){
                            let status = setStatusMessage(content.displayMessage);
                            $fragment.appendChild(status);
                        }
                    }
                }
                // CONTENT DATA - DATA
                else if(content.type.toUpperCase() == 'COMMENTSWALL'){
                    preview = document.createElement('div');
                    preview.innerHTML = previewClean;
                    if(props.editMode) preview.classList.add('editable-content');
                    let $links = preview.getElementsByTagName('a');
                    for(let link of $links){
                        link.addEventListener('click', (e)=>{
                            e.preventDefault();
                            if(!props.editMode) router.push(`/course/${props.courseId}/module/${props.moduleId}/muro/${content.id}`)
                        })
                        link.setAttribute('href', !props.editMode ? `/course/${props.courseId}/module/${props.moduleId}/muro/${content.id}` : '')
                    }
                    $fragment.appendChild(preview);
                    if(content.displayMessage && !props.editMode){
                        if( !(moduleData.value.courseIsFinished && content.displayMessage == 'CONTENT_PENDING_OUT_TIME') ){
                            let status = setStatusMessage(content.displayMessage);
                            $fragment.appendChild(status);
                        }
                    }
                    // Find or create the button element for the commentswall
                    let commentswallButton = preview.querySelector('a'); // Assuming the button already exists
                    if (!commentswallButton) {
                        commentswallButton = document.createElement('a');
                        preview.appendChild(commentswallButton); // Append the button if it's newly created
                    }

                    // get content.data.Data
                    let contentData = content.data.Data;
                    let contentType = 'commentswall';
                    let commentsWallHeaders = content.commentsWallHeaders;

                    // set class
                    commentswallButton.classList.add('commentswall-button');
                    if (commentswallButton) {
                        commentswallButton.addEventListener('click', () => openNewModal(contentData, contentType, commentsWallHeaders));
                    }
                }
                let view = preview || data;
                view.classList.add(`contentId-${content.id}`)
                // Add classes based on content type
                if (content.type.toUpperCase() === 'FORUM') {
                    view.classList.add('contentType-FORUM');
                } else if (content.type.toUpperCase() === 'ATTACH') {
                    view.classList.add('contentType-ATTACH');
                }
                //Add loaders for genially
                let $iframes = view.getElementsByTagName('iframe');
                for(let $iframe of $iframes){
                    //$iframe.loading = 'lazy';
                    let $parent = $iframe.parentNode;
                    $iframe.style.display = 'none';
                    let $iframeLoader = document.createElement('div');
                    $iframeLoader.innerHTML = 'Cargando contenido...';
                    $iframeLoader.classList.add('iframe-loader');
                    $parent.appendChild($iframeLoader);
                    $parent.style.minHeight = '600px';
                    $iframe.addEventListener('load', ()=> {
                        $iframe.style.visibility = 'hidden';
                        $iframe.style.display = 'block';
                        setTimeout(()=>{
                            $iframe.style.visibility = 'visible';
                            $iframeLoader.remove();
                        },1000)
                    })                    
                }

                //Add module editor options
                if(props.editMode){
                    if(content.htmlType != 'PORTADA'){
                        let options = document.createElement('div');
                        options.classList.add(`editable-content__options`);
                        options.classList.add(`editable-content--${content.id}`);
                        if(content.htmlType != 'DIVISION'){
                            let orderUp = document.createElement('span');
                            orderUp.classList.add('editable-content__options__upOrder')
                            orderUp.innerHTML = '<i class="material-icons">arrow_upward</i>';

                            let orderDown = document.createElement('span');
                            orderDown.classList.add('editable-content__options__downOrder')
                            orderDown.innerHTML = '<i class="material-icons">arrow_downward</i>';

                            if (props.status === 'A1') {
                                let $iconUp = orderUp.querySelector('.material-icons');
                                $iconUp.style.opacity = .5;
                                $iconUp.style.cursor = 'default';
                                orderUp.style.pointerEvents = 'none';

                                let $iconDown = orderDown.querySelector('.material-icons');
                                $iconDown.style.opacity = .5;
                                $iconDown.style.cursor = 'default';
                                orderDown.style.pointerEvents = 'none';
                            } else {
                                orderUp.addEventListener('click', () => orderContent('up', content));
                                orderDown.addEventListener('click', () => orderContent('down', content));
                            }

                            options.appendChild(orderUp);
                            options.appendChild(orderDown);


                            let cancelOrder = document.createElement('span');
                            cancelOrder.classList.add('editable-content__options__cancelOrder')
                            cancelOrder.innerHTML = '<i class="material-icons">close</i>';
                            cancelOrder.addEventListener('click', ()=> cancelContentOrder());
                            options.appendChild(cancelOrder);

                            let confirmOrder = document.createElement('span');
                            confirmOrder.classList.add('editable-content__options__confirmOrder')
                            confirmOrder.innerHTML = '<i class="material-icons">done</i>';
                            confirmOrder.addEventListener('click', ()=> confirmContentOrder());
                            options.appendChild(confirmOrder);
            
                            let edit = document.createElement('span');
                            edit.innerHTML = '<i class="material-icons">edit</i>';
                            edit.addEventListener('click', ()=> emit('editContent',content));
                            options.appendChild(edit);
            
                            let copy = document.createElement('span');
                            copy.innerHTML = '<i class="material-icons">content_copy</i>';

                            if (props.status === 'A1') {
                                let $icon = copy.querySelector('.material-icons');
                                $icon.style.opacity = .5;
                                $icon.style.cursor = 'default';
                                // Optionally, you could also explicitly disable pointer events
                                copy.style.pointerEvents = 'none';
                            } else {
                                copy.addEventListener('click', () => {
                                    // Perform copy action
                                    emit('copyContent', content);
                                });
                            }

                            options.appendChild(copy);

                        }
        
                        let remove = document.createElement('span');
                        remove.innerHTML = '<i class="material-icons">delete_outline</i>';

                        if ((props.finalPractice?.toUpperCase() == 'TRIP' && (content.type == 'ATTACH' || content.type == 'TRIP')) ||
                            (props.finalPractice?.toUpperCase() == 'CONTENTSHARE' && (content.type == 'ATTACH' || content.type == 'CONTENTSHARE')) ||
                            props.status === 'A1') {

                            let $icon = remove.querySelector('.material-icons');
                            $icon.style.opacity = .5;
                            $icon.style.cursor = 'default';
                            // Optionally, you could also explicitly disable pointer events
                            remove.style.pointerEvents = 'none';
                        } else {
                            remove.addEventListener('click', () => {
                                // Perform remove action
                                emit('removeContent', content);
                            });
                        }

                        options.appendChild(remove);
                        (preview || data).appendChild(options);

                    }
                    //else { (preview || data).classList.remove('editable-content') }

                    let addContent = document.createElement('div');
                    addContent.classList.add('add-content');

                    let btnAdd = document.createElement('button');
                    btnAdd.innerHTML = '<i class="material-icons">add_circle</i>';

                    // Check if status is 'A1' and disable the button if true
                    btnAdd.disabled = props.status === 'A1';

                    btnAdd.addEventListener('click', () => {
                        if (props.status !== 'A1') {
                            emit('addContent', content.orderNumber);
                        }
                    });

                    addContent.appendChild(btnAdd);

                    (preview || data).appendChild(addContent)
                }    
            });
            container.appendChild($fragment);
            moduleDataLoaded.value = true;
            emit('dataLoaded', moduleData.value)
        }else{
            container.innerHTML = '<span>No hay contenidos para mostrar</span>';
        }
    } catch (error) {
        console.log(error);
        if(error.response.data.includes('Module is not open')){
            moduleLockedDate.value = error.response.data.split('_')[1].split(' ')[0];
            moduleLocked.value = true;
        }
    }
}     

watch(()=>props.moduleId,()=>{
    if(props.moduleId) getModule(props.moduleId);
})

watch(()=>props.finalPractice, async()=>{
    let req = await store.dispatch('contentEditor_changeFinalPracticeType', {type: props.finalPractice, courseId: route.params.courseCfgId})
    let moduleId = req.data.moduleId;
    router.push(`/contents/mastercourses/${route.params.courseCfgId}/moduleEditor/${moduleId}?type=${props.finalPractice}`)
    //getModule(props.moduleId);
})

onMounted(()=>{
    getModule(props.moduleId)
})

defineExpose({
  getModule
});

</script>

<style lang="scss">
@import '@/styles/main.scss';


.content-container {
    padding-bottom: 22px;

    .content-container__finish-button__button {
        font-weight: 600;
        background-color: var(--green);
        color: #fff;
        border-radius: 99999px;
        padding: 12px 28px;
        display: flex;
        align-items: center;
        gap: 8px;
        line-height: 17px;
    }
}
#module-content{
    display: flex;
    flex-direction: column;
    gap: 22px;
    font-size: 18px !important;
    padding-bottom: 22px;
    *{
        font-size: 18px !important;
    }
    a{
        color: $green;
        text-decoration: underline;
        font-size: 17px !important;
    }
    #imgHeader{
        margin-right: 20px;
        padding: 50px;
        height: 500px;
        text-align: center;
        border-radius: 15px;
        outline: 0;
        background-size: cover;
        background-position: left;
        background-repeat: no-repeat;
        @media screen and (max-width: $bpMedium){
            margin: 0;
            background-position: center;
            height: 320px;
        }
        @media screen and (max-width: $bpSmall){
            margin: 0;
            background-position: center;
            height: 240px;
        }
    }
    .imgHeader{
        width: fit-content;
        max-width: 100%;
        margin: 0 auto;
        border-radius: 15px;
        img{
            max-width: 100%;
            object-fit: contain;
            border-radius: 15px;
        }
    }
    .portada-content{
        &:hover{
            .add-content{
                display: block;
            }
        }
    }
    .content-image{
        width: 100%;
        margin: 8px 0;
        text-align: center;
        img{
            max-width: 100%;
        }
    }
    .editable-content{
        position: relative;
        &__options{
            visibility: hidden;
            position: absolute;
            top: 32px;
            right: 22px;
            width: fit-content;
            padding: 8px 16px 4px 12px;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 15px;
            border-radius: 44px;
            border: 1px solid #009696;
            background: #FFF;
            span{
                height: fit-content;
                &:last-child{
                    .material-icons{
                        font-size: 24px;
                    }
                }
            }
            .material-icons{
                color: $green;
                font-size: 22px;
                cursor: pointer;
            }
            &__cancelOrder,&__confirmOrder{
                display: none;
            }
        }
        &:hover{
            margin: 12px 0;
            padding-top: 26px;
            border-top: 1px dashed #BDBDBD;
            .editable-content__options{
                visibility: visible;
            }
            .add-content{
                display: block;
            }
        }
        &.division{
            padding: 16px 0;
        }
    }
    .editable-content, .portada-content{
        transition: all .6s ease;
        .add-content {
            margin-top: 46px;
            position: relative;
            display: none;
            text-align: center;
            &::before {
                content: "";
                border-top: 1px dashed #BDBDBD; /* Estilo de línea punteada y color */
                position: absolute;
                top: 38%; /* Coloca la línea en el centro vertical */
                left: 0;
                right: 0;
            }
            button {
                position: relative;
                z-index: 1; /* Coloca el botón sobre la línea */
                .material-icons{
                    color: $green;
                    font-size: 42px !important;
                }
            }
        }
    }


    &.edit-order-mode{
        transform: scale(0.97);
        transform-origin: top center;
        .editable-content{
            transition: none;
            opacity: .4;
            &__options{
                display: none;
            }
            &.edit-order-itemActive{
                margin: 12px 0;
                padding: 8px;
                opacity: 1;
                box-shadow: 5px 5px 35px 10px rgba(217, 217, 217, 0.5);
                border-radius: 6px;
                &:hover{
                    margin: 12px 0;
                    padding: 8px;
                }
                .editable-content__options{
                    display: flex;
                    visibility: visible;
                    // &.saving-order{
                    //     //opacity: .4;
                    // }
                    span{
                        display: none;
                    }
                    &__upOrder,&__downOrder,&__cancelOrder,&__confirmOrder{
                        display: inline-block !important;
                    }
                }
            }
            &:hover{
                margin: 0;
                padding: 0;
                min-height: 0;
                border-top: none;
            }
            .add-content, &:hover .add-content{
                display: none;
            }
        }
        .portada-content{
            &:hover{
                .add-content{
                    display: none;
                }
            }
        }
    }

    .iframe-loader{
        width: 100%;
        height: 600px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 22px;
        font-weight: 700;
        color: $darkgray;
        border: 1px solid $darkgray;
    }

}
/* ContentShare */
.finalPractice__cards{ //Le cambie la clase de finalPractice para darle otros estilos
    display: flex;
    align-items: center;
    gap: 24px;
    .finalPractice__card{
        border-radius: 10px;
        cursor: pointer;
        padding: 4px;
        //width: 100%;
        width: 285px;
        height: 120px;
        transition: transform .2s ease;
        &:hover{
            transform: scale(1.05);
        }
        img{
            max-width: 285px;
            max-height: 120px;
            width: 100%;
            height: 100%;
            border-radius: 10px;
            object-fit: cover;
        }
        &--disabled{
            @extend .finalPractice__card;
            cursor: default;
            opacity: .6;
            &:hover{
                transform: none;
            }
        }
    }

}

.contentShare__modal{
    position: relative;
    width: calc(100% - 24px);
    max-width: 1000px;
    // height: fit-content;
    //max-height: 84vh;
    padding: 22px;
    //overflow-y: auto;
    display: flex;
    flex-direction: column;
    // gap: 28px;
    border-radius: 10px;
    background: #FFF;
    box-shadow: 5px 5px 35px 0px rgba(217, 217, 217, 0.50);
    height: 100%;
    max-height: 80vh;

    @media (max-width:980px) {
        padding: 8px;
    }
    
    &__close{
        position: absolute;
        right: 14px;
        top: 12px;
        font-size: 26px;
        font-weight: 600;
        cursor: pointer;
    }
    &__body {
        padding-top: 16px;
        max-height: 80vh;
        overflow-y: auto;
        padding-right: 2px;

        &::-webkit-scrollbar-track {
            border-radius: 100px;
            background-color: rgba(184, 184, 184, 0.1);
        }
        &::-webkit-scrollbar {
            width: 3px;
            height: 3px;
            background-color: transparent;
            margin: 10px;
        }
        &::-webkit-scrollbar-thumb {
            border-radius: 100px;
            background: map-get($dark, 400);
            position: absolute;
        }
    }
    &_iframe{

        &__disclaimer {
            font-size: 14px;
            margin-bottom: 16px;
        }
    }
    &_views{
        display: flex;
        align-items: center;
        width: 100%;
        border-bottom: 1px solid #e6e6e6;
        gap: 12px;
    }
    &_view{
        padding: 12px 8px;
        padding-bottom: 16px;
        font-size: 14px;
        font-weight: 600;
        color: #212121;
        cursor: pointer;
        &--active{
            padding: 12px 8px;
            font-size: 14px;
            font-weight: 600;
            color: $green;
            border-bottom: 3px solid $green;
            cursor: pointer;
        }
    }
    &__buttons{
        margin: 0 auto;
        display: flex;
        width: 100%;
        align-items: center;
        gap: 24px;
        justify-content: center;
        padding: 16px 0;
    }
    &_button:first-child{
        color: $green;
        font-size: 16px;
        font-weight: 600;
    }
    &_button:last-child{
        font-size: 16px;
        font-weight: 600;
        background-color: $green;
        color: #fff;
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 12px 28px;
        border-radius: 44px;
        .material-icons-outlined{
            font-size: 18px;
        }
    }
}


// contentPreview modal
.contentPreview__modal{
    position: relative;
    width: calc(100% - 24px);
    max-width: 1000px;
    height: fit-content;
    padding: 22px;
    display: flex;
    flex-direction: column;
    gap: 28px;
    border-radius: 10px;
    background: #FFF;
    box-shadow: 5px 5px 35px 0px rgba(217, 217, 217, 0.50);

    @media (max-width:980px) {
        padding: 8px;
    }
    
    &__body {
        max-height: 80vh;
        overflow-y: auto;
        padding-right: 2px;

        .module_muro {
            height: 100px;
        }

        &::-webkit-scrollbar-track {
            border-radius: 100px;
            background-color: rgba(184, 184, 184, 0.1);
        }
        &::-webkit-scrollbar {
            width: 3px;
            height: 3px;
            background-color: transparent;
            margin: 10px;
        }
        &::-webkit-scrollbar-thumb {
            border-radius: 100px;
            background: map-get($dark, 400);
            position: absolute;
        }

        *{
            font-size: 16px!important;
        }
    }

    &__date{
        font-size: 12px!important;
        font-weight: 700;
        text-align: right;
    }

    &__close{
        // position: absolute;
        // right: 14px;
        // top: 12px;
        font-size: 24px;
        font-weight: 600;
        cursor: pointer;
    }
    &_iframe{
        height: 300px;

        &__disclaimer {
            font-size: 14px;
            margin-bottom: 16px;
        }
    }
    &_views{
        display: flgfex;
        align-items: center;
        width: 100%;
        gap: 12px;
    }
    &_view{
        padding: 12px 8px;
        padding-bottom: 16px;
        font-size: 14px;
        font-weight: 600;
        color: #212121;
        cursor: pointer;
        &--active{
            padding: 12px 8px;
            font-size: 14px;
            font-weight: 600;
            color: $green;
            border-bottom: 3px solid $green;
            cursor: pointer;
        }
    }
    &__buttons{
        margin: 0 auto;
        display: flex;
        width: 100%;
        align-items: center;
        gap: 24px;
        justify-content: center;
    }
    &_button:first-child{
        color: $green;
        font-size: 16px;
        font-weight: 600;
    }
    &_button:last-child{
        font-size: 16px;
        font-weight: 600;
        background-color: $green;
        color: #fff;
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 12px 28px;
        border-radius: 44px;
        .material-icons-outlined{
            font-size: 18px;
        }
    }
    &__title{
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #7D7D7D80;
        padding-bottom: 16px;
        h2{
            font-size: 16px;
            font-weight: 700;
            color: #212121;
        }
    }
}


.forum {
    &__actions{
        width: 100%;
        display: flex;
        justify-content: center;
        gap: 32px;
        border-top: 1px solid #7D7D7D80;
        border-bottom: 1px solid #7D7D7D80;
        padding-top: 24px;
        padding-bottom: 24px;
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 16px;

        button{
            display: inline-flex;
            align-items: center;
            gap: 12px;
            cursor: pointer;
        }
        .material-icons-outlined{
            font-size: 18px;
        }
    }
}

.activity__actions {
    h3 {
        margin-bottom: 8px;
    }
    p {
        margin-bottom: 16px;
    }
}



.commentsWall {
    &__swipe {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 12px 0;
        i {
            font-size: 24px;
            color: $green;
        }
        span {
            font-weight: 700;
            color: $black;
        }
    }
}




.module{
  &_muro_container {
    overflow: auto;
    overflow-y: hidden;
    &::-webkit-scrollbar-track {
      border-radius: 100px;
      background-color: rgba(0,0,0,.1);
    }
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      background-color: transparent;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 100px;
      background: map-get($dark, 400);
      position: absolute;
      border: 4px solid rgba(0, 0, 0, 0);
    }
    .module_muro:nth-child(1) {
      height: fit-content;
      .module_muro__column {
          height: auto;
      }
      .module_muro__header {
        display: flex;
        flex-direction: column;
        justify-content: center;height: 100%;
      }
    }
  }
  &_muro{
    overflow: visible;
    padding-bottom: 6px;
    margin-top: 18px;

    display: flex;
    gap: 18px;
    .dropdown{
    width: fit-content;


    &__face{
        padding: 0;
        border-radius:0;
        border: none;
        width: fit-content
    }
    &__items{
        top: 0;
        left: 100%;
        flex-direction: row;
        width: 0;
        padding:0;
        visibility: hidden;
        li{
            font-size: 17px;
        }
    }
    input {
        display: none;
        &:checked ~ .dropdown__items {
        top: calc(100% + -28px);
        visibility: visible;
        left: -420%;
        padding: 10px;
        width: fit-content;
        opacity: 1;
        }
      }
    }
    &::-webkit-scrollbar-track {
      border-radius: 100px;
      background-color: rgba(0,0,0,.1);
    }
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      background-color: transparent;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 100px;
      background: map-get($dark, 400);
      position: absolute;
      border: 4px solid rgba(0, 0, 0, 0);
    }
    &__fetchMoreComments{
      font-weight: 600;
      font-size: 18px;
      margin: 12px 0;
      color: $green;
    }
    &__button{
      font-size: 16px;
      font-weight: 600;
      outline: none;
      padding: 12px 0;
      &--cancel{
        @extend .module_muro__button;
        color: $green;
      }
      &--submit{
        @extend .module_muro__button;
        background-color: $green;
        color: #fff;
        width: 165px;
        border-radius: 44px;
      }
    }
    .quillWrapper{
      .ql-toolbar{
        background-color: #fff;
      }
      .ql-container{
        background-color: #fff;
        height: fit-content;
      }
    }
    &__title{
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 12px 0;
      @media (max-width: 700px){
        flex-direction: column;
      }
      &-activity{
        font-size: 22px;
        font-weight: 700;
      }
      &-date{
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: 600;
        gap: 6px;
        .material-icons-outlined{
          font-size: 18px;
        }
      }
    }
    &__column{
      display: flex;
      flex-direction: column;
      gap: 18px;
      width: 100%;
      min-width: 280px;
      max-height: 70vh;
      padding-top: 12px;
      padding-right: 4px;
      @media (min-height: 800px){
        max-height: 77vh;
      }
      &::-webkit-scrollbar-track {
        border-radius: 100px;
        background-color: rgba(0,0,0,.1);
      }
      &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background-color: transparent;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 100px;
        background: map-get($dark, 400);
        position: absolute;
        border: 4px solid rgba(0, 0, 0, 0);
      }
    }
    &__header{
      color: $green;
      font-size: 16px;
      font-weight: 700;
      width: 100%;
      padding: 12px 0;
      border: 2px solid $green;
      border-radius: 10px;
      text-align: center;
    }
    &__addComment{
      display: flex;
      align-items: center;
      gap: 6px;
      color: $green;
      font-size: 16px;
      font-weight: 600;
      align-self: center;
      .material-icons{
        font-size: 18px;
      }
    }
    &__comment{
      padding: 18px 16px;
      border-radius: 10px;
      background-color: #f6f6f6;
      display: flex;
      flex-direction: column;
      gap: 12px;
    }
    &__name{
      font-size: 14px;
      font-weight: 400;
      color: #7D7D7D;
      strong{
        font-weight: 600;
        color: $green;
      }
    }
    &__image{
      width: 100%;
      max-height: 285px;
    }
    &__content{
      font-weight: 400;
      font-size: 18px;
      img{
        max-width: 100%;
        border-radius: 10px;
      }
      &--deleted{
        font-weight: 400;
        font-size: 13px;
        color: #7D7D7D;
        //text-align: center;
      }
    }
    &__buttons{
      display: flex;
      align-items: center;
      gap: 12px;
      margin: 12px 0;
      padding-left: 12px;
      &:disabled{
        cursor: pointer;
        opacity: .6;
      }
      &--active{
        font-weight: 600;
        font-size: 10px;
        display: flex;
        align-items: center;
        gap: 8px;
        color: $green !important;
        .material-icons-outlined{
          font-size: 16px;
          color: $green;
        }
      }
      button{
        font-weight: 600;
        font-size: 10px;
        display: flex;
        align-items: center;
        gap: 4px;
        color: #000;
        .material-icons-outlined{
          font-size: 16px;
        }
      }
    }
    &__childrenComment{
      width: 100%;
      display: flex;
      align-items: flex-start;
      position: relative;
      &_lines{
        height: 100%;
        width: 15%;
        padding-left: 12px;
      }
      &_line1{
        width: calc(15% - 12px);
        height: 50%;
        position: absolute;
        border-bottom: 1px solid #D2D2D2;
        border-left: 1px solid #D2D2D2;
      }
      &_line2{
        width: calc(15% - 12px);
        height: 100%;
        position: absolute;
        border-left: 1px solid #D2D2D2;
      }
      &_container{
        width: 85%;
        background-color: #F6F6F6;
        padding: 12px 18px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        gap: 8px;
      }
      &_name{
        font-size: 14px;
        font-weight: 400;
        color: #7D7D7D;
        strong{
          font-weight: 600;
          color: $green;
        }
      }
      &_content{
        font-size: 16px;
        font-weight: 400;
        img{
          max-width: 100%;
        }
      }
    }
  }
}




.editable-content.division > div {
  margin: 20px 0px 15px 0px;
  height: auto !important;
}

.editable-content.division > div > div {
  width: 100% !important;
  height: 84px !important;
  background: transparent !important;
  position: relative;
  overflow: hidden;
  border-radius: 0 !important;
}

.editable-content.division > div > div::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 1px;
  background: rgba(125, 125, 125, 0.5);
  box-shadow: 0 4px 4px 1px rgba(125, 125, 125, 0.15);
}

</style>